/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var collectionFilter = document.getElementById( 'collectionFilter' ) || false;

if( collectionFilter ) {
  collectionFilter.addEventListener( 'change', function() {
    document.location.href = '?sort_by=' + this.options[ this.selectedIndex ].value;
  } );
}

jQuery('#notify-me').click(function() {

jQuery('#notify-me-wrapper').fadeIn();
  jQuery('#notify-me-text').hide();

return false;
} );
function LoadLibrary(liburl,callback){
    var jscript = document.createElement("script");
    jscript.type = 'text/javascript';
    jscript.src = liburl;
    //for IE type browsers
    if (jscript.readyState) { 
        jscript.onreadystatechange = function () {
            if (jscript.readyState == "loaded" || jscript.readyState == "complete") {
                jscript.onreadystatechange = null;
                callback();
            }
        };
    } else {
        jscript.onload = function () {
            callback();
        };
    }
    document.getElementsByTagName("head")[0].appendChild(jscript);
}


if (!window.jQuery) {  
    LoadLibrary('https://code.jquery.com/jquery-3.3.1.min.js',
        function(){
            console.log('jQuery loaded');
        }
    );         
}



function defer(method) {
    if (window.jQuery) {
        method();
    } else {
        setTimeout(function() { defer(method) }, 50);
    }
}

defer(function(){
$(document).ready(function(){
	$( ".Product__Slideshow .Product__SlideItem" ).clone(true).appendTo( ".slide-placeholder" );
});


	window.VIG = window.VIG || {};
	VIG.loaded = false;
	VIG.VariantChangeCallback = function(){
    		var visible_ids = $('.slide-placeholder img:visible').map(function() {
    			return $(this).data('image-id');
    		}).get();
    		$(".flickity-page-dots button").hide();
          	var visible_index = 0;
    		var slidesToAdd = [];
    
    		visible_ids.forEach(function(element) {
    		slidesToAdd.push($('.slide-placeholder [data-image-id='+element+']').closest('.Product__SlideItem'));
    		});
    		
            var $sliders = $('.Product__Slideshow.flickity-enabled');
          
        	  $sliders.each(function() {
                
                var $slider = $(this);
                var $sliderInstance = Flickity.data(this);
                if ($sliderInstance != undefined ) {
                  
                    $sliderInstance.remove($('.Product__Slideshow .Product__SlideItem'));
                    slidesToAdd.forEach(function(element) {
                    	$sliderInstance.append(element.clone(true));
                      	visible_index = element.attr('data-image-media-position');
                      	$(".flickity-page-dots button[data-index='"+visible_index+"']").show();
                    });
                } 
                else{
                console.log('slider instance undefined');
                }
            });		
    		
          $(".flickity-page-dots button[data-index]:visible").first().addClass('is-selected');
            window.scrollTo(0, 0);
    
        }
	
});/*FIXED BY VIP:2020-06-14 15:31:04 UTC*/

$(document).ready(function(){
  $('.height-auto').matchHeight({property:'height'});
  
  $('.height-auto').matchHeight({property:'height'});
  
  /*if ($(window).width() < 768) {
    $('.grid').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: false,
      arrows: false,
      fade: false,
      responsive: [
        {
          breakpoint: 481,
          settings: {
            drage: false,
            centerMode: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  } else {}*/

  $('.kioskwrap').slick({
    dots: false,
    arrow: true,
    infinite: true,
    fade: false,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll:1,
    settings: 'slick',
    responsive: [
      {
        breakpoint: 768,
         settings: "unslick"
      }
    ]
  });
  
});


$(function () {
  var According = function(el, multiple) {
    this.el = el || {};
    this.multiple = multiple || false;
    
    var link = this.el.find('.Footer__Title');
    link.on('click', {
      el: this.el,
      multiple: this.multiple
    }, this.dropdown)
  }
  According.prototype.dropdown = function(e) {
    var $el = e.data.el;
    $this = $(this),
      $next = $this.next();
    
    $next.slideToggle();
    $this.parent().toggleClass('open');
    
    if (!e.data.multiple) {
      $el.find('.Linklist').not($next).slideUp().parent().removeClass('open');
    };
  }
  var accord = new According($('.faq-element'), false);
});

$(window).resize(function(){
  $('.height-auto').matchHeight({property:'height'});
  
//   if ($(window).width() < 768) {
//     $('.grid').slick({
//       infinite: true,
//       slidesToShow: 3,
//       slidesToScroll: 3,
//       dots: false,
//       arrows: false,
//       responsive: [
//         {
//           breakpoint: 480,
//           settings: {
//             slidesToShow: 2,
//             slidesToScroll: 2
//           }
//         }
//       ]
//     });
//   } else {}
  
});
function valueChanged() {
  if($('#termcheckobx').is(":checked"))   {
    $('#wcchecoutbtn').attr("disabled", false);
    $('#wcchecoutbtn').css('opacity', '1');
  }
  else{
    $('#wcchecoutbtn').attr("disabled", true);
    $('#wcchecoutbtn').css('opacity', '0.4');
  }
};
$('.popuar_Cls').slick({
  dots: false,
  arrows: false,
  infinite: false,
  fade: false,
  speed: 1000,
  slidesToShow:4,
  slidesToScroll:1,
  responsive: [
    {
      breakpoint: 641,
      settings: {
        centerMode: true,
        slidesToShow:2,
        centerPadding: '22%',
        infinite: true
      }
    }
  ]
});
$('.r_wc_proclsslider').slick({
  dots: false,
  arrows: true,
  infinite: true,
  slidesToShow:4,
  slidesToScroll:1,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow:3
      }
    },
    {
      breakpoint: 641,
      settings: {
        slidesToShow:2,
        arrows:false,
        centerMode: true,
        centerPadding: '15%',
      }
    }
  ]
});
$('.ftr_arw').on('click',function(e){
  e.preventDefault();
  $(this).parent('.ftr_title').toggleClass('active');
  $(this).parent('.ftr_title').next('.ftr_mobdata').slideToggle();
});
$(document).on('click','.sizegrid_btn',function(e){
  e.preventDefault();
  $(this).parent('li').addClass('active').siblings().removeClass('active');  
  $(this).closest('.look_pro_Slide').find('.look_metabtn').addClass('active');
});
$(document).on('click','.mobshowmoblook',function(e){
  e.preventDefault();
  $(this).parent('li').addClass('active').siblings().removeClass('active');  
  $(this).closest('.look_pro_Slide').find('.look_metabtn').addClass('active');
  $(this).hide().closest('.look_pro_Slide').siblings().find('.mobshowmoblook').show();
  $(this).closest('.look_pro_Slide').siblings().find('.showmoblook').hide();
  $('.showmoblook,.look_meta_size').hide();
  $(this).closest('.look_pro_Slide').find('.showmoblook').show();
  $(this).closest('.look_pro_Slide').find('.look_meta_size').show();
});
$(document).on('click','.look_metabtn',function(e){
  e.preventDefault();  
  var id = $(this).closest('.look_pro_Slide').find('.size_grid li.active .sizegrid_btn').data('id');
  var thisbtn = $(this).closest('.look_pro_Slide').find('.error_msgsize');
  var quantity = 1;
  var data = {
    'quantity': quantity,
    'id': id,
  };
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function(data) {
      document.documentElement.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: id,
          quantity: parseInt(quantity)
        }
      }));
    },
    error: function(XMLHttpRequest) {
      var response = eval('(' + XMLHttpRequest.responseText + ')');
      (thisbtn).text(response.description);
      setTimeout(function(){
        $(thisbtn).text('');
      }, 1500);
    }
  });
});
$('.look_pro_slider').slick({
  dots: false,
  arrows: true,
  infinite: true,
  slidesToShow:3,
  slidesToScroll:1,
  responsive: [    
    {
      breakpoint: 992,
      settings: "unslick"
    }
  ]
});
setTimeout(function(){
//   $('.ProductRecommendations .look_pro_slider').slick({
//     dots: false,
//     arrows: true,
//     infinite: true,
//     slidesToShow:3,
//     slidesToScroll:1,
//     responsive: [    
//       {
//         breakpoint: 992,
//         settings: "unslick"
//       }
//     ]
//   });
}, 3000);
// 1st carousel, main
$(document).ready(function(e){
  $('.Product__Slideshow').flickity({
    prevNextButtons: true,
    pageDots: false
  });
});
$(window).on("load resize",function(e){
  $('.Product__Slideshow').flickity({
    prevNextButtons: true,
    pageDots: false
  });
});
$(document).on('click','.Product__SlideshowNavImage',function(e){
	var mediaid = $(this).data('media-id');
  console.log('f');
  	 $('.Product__Slideshow').flickity( 'select', $(this).data('index'));
});
if($('.coll_descouter').height()>319){
  $('.coll_descouter').addClass('active');
}
$('.collplus').on('click',function(e){
  e.preventDefault();
  $(this).closest('.coll_descouter').addClass('morecollection');
  $(this).closest('.coll_descouter').removeClass('active');
});
$('.collminus').on('click',function(e){
  e.preventDefault();
  $(this).closest('.coll_descouter').removeClass('morecollection');
  $(this).closest('.coll_descouter').addClass('active');
});
var recomm_section = $('[data-section-type="product-recommendations"]');
var rec_proid = recomm_section.attr('data-proid');
var rec_prolimit = recomm_section.attr('data-procount');
fetch("/recommendations/products?section_id=product-recommendations&product_id="+rec_proid+"&limit="+rec_prolimit)
.then(response => response.text())
.then((text) => {
  $('.ProductRecommendations .look_pro_slider').slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow:3,
    slidesToScroll:1,
    responsive: [    
      {
        breakpoint: 992,
        settings: "unslick"
      }
    ]
  });
});